import React from "react";
import { Helmet } from "react-helmet-async";

const seoData = {
  "/": {
    title: "Grupo BG | Distribución de Consumo Masivo en Ecuador",
    description: "Grupo BG - Grupo Empresarial de Distribución. Conectamos marcas con puntos de venta en la zona centro del Ecuador. +17 años, 6 provincias, 14 marcas aliadas, +6K clientes activos.",
    keywords: "distribución consumo masivo Ecuador, Grupo BG, Rio BG Distribuciones, distribuidora Riobamba"
  },
  "/nosotros": {
    title: "Nosotros | Grupo BG - Quiénes Somos",
    description: "Conoce a Grupo BG, empresa de distribución con más de 17 años de experiencia en la zona centro del Ecuador. Misión, visión y valores corporativos.",
    keywords: "quiénes somos Grupo BG, empresa distribución Ecuador, historia Rio BG Distribuciones"
  },
  "/cobertura": {
    title: "Cobertura Geográfica | Grupo BG - 6 Provincias en Ecuador",
    description: "Cobertura en Chimborazo, Bolívar, Morona Santiago, Tungurahua, Pastaza y Napo. Presencia estratégica en la zona centro del Ecuador con +6K clientes activos.",
    keywords: "cobertura distribución Ecuador, Chimborazo, Bolívar, Morona Santiago, Tungurahua, Pastaza, Napo"
  },
  "/marcas": {
    title: "Nuestras Marcas | Grupo BG - 14 Marcas Aliadas",
    description: "Distribuimos 14 marcas líderes: Arcor, Estrella, Minerva, Ingesa, Inalecsa, Carli Snacks, Dulcenac, Elite, Sunny, Hornimans, Sumesa, Cartago, Sangay Foods, Forestea.",
    keywords: "marcas distribución Ecuador, Arcor, Estrella, Minerva, Sumesa, Forestea, distribuidora marcas"
  },
  "/modelo": {
    title: "Modelo de Distribución | Grupo BG - Logística Eficiente",
    description: "Nuestro modelo de distribución: fuerza de ventas estructurada, distribución numérica, ejecución en punto de venta y logística eficiente.",
    keywords: "modelo distribución, logística Ecuador, fuerza ventas, merchandising, distribución numérica"
  },
  "/contacto": {
    title: "Contáctanos | Grupo BG - Rio BG Distribuciones",
    description: "Contáctanos para distribución de productos en Ecuador. Bodegas en Riobamba, Guaranda, Macas y Ambato. WhatsApp: 0983112804. Email: contacto@grupobg.com.ec",
    keywords: "contacto Grupo BG, distribución productos Ecuador, WhatsApp Rio BG, bodegas Riobamba Guaranda Macas Ambato"
  },
  "/blog": {
    title: "Blog | Grupo BG - Distribución y Logística en Ecuador",
    description: "Artículos sobre distribución de consumo masivo, logística, mercado ecuatoriano y cómo elegir el mejor distribuidor para tu marca en la zona centro del Ecuador.",
    keywords: "blog distribución Ecuador, artículos consumo masivo, logística distribución Ecuador, distribuidor productos Ecuador, mercado Riobamba Ambato Guaranda Macas"
  }
};

export const PageSEO = ({ path }) => {
  const data = seoData[path] || seoData["/"];
  const url = `https://grupobg.com.ec${path === "/" ? "" : path}`;

  return (
    <Helmet>
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
};
